import { Personnage } from '../types';

export const personnages: Personnage[] = [
  // Personnages existants
  {
    id: 'p001',
    prenom: 'Jean',
    nom: 'Tremblay',
    age: 45,
    sexe: 'H',
    profession: 'Enseignant au secondaire',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Marié(e)',
    enfants: 2,
    groupeSanguin: 'O+',
    conditionsMedicales: [
      {
        nom: 'Hypertension',
        description: 'Hypertension légère contrôlée par médication',
        medicaments: ['Ramipril 5mg']
      },
      {
        nom: 'Allergie saisonnière',
        description: 'Rhinite allergique au pollen',
        medicaments: ['Reactine 10mg']
      }
    ],
    medicaments: ['Ramipril 5mg', 'Reactine 10mg'],
    allergies: ['Pollen'],
    traits: ['Patient', 'Organisé', 'Méthodique'],
    comportement: ['Calme en situation de stress', 'Tendance à minimiser ses problèmes de santé'],
    histoire: 'Enseignant dévoué depuis 20 ans, père de deux adolescents. Impliqué dans sa communauté comme entraîneur de soccer.',
    contacts: [
      { relation: 'Épouse', personnageId: 'p002' },
      { relation: 'Fils', personnageId: 'p003' },
      { relation: 'Fille', personnageId: 'p004' }
    ]
  },
  {
    id: 'p002',
    prenom: 'Marie',
    nom: 'Tremblay',
    age: 43,
    sexe: 'F',
    profession: 'Pharmacienne',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Marié(e)',
    enfants: 2,
    groupeSanguin: 'A+',
    conditionsMedicales: [
      {
        nom: 'Migraine chronique',
        description: 'Migraines récurrentes avec aura',
        medicaments: ['Sumatriptan 50mg']
      }
    ],
    medicaments: ['Sumatriptan 50mg'],
    allergies: [],
    traits: ['Empathique', 'Professionnelle', 'Attentive'],
    comportement: ['Proactive avec sa santé', 'Tendance à trop travailler'],
    histoire: 'Pharmacienne respectée, elle jongle entre sa carrière et sa famille. Passionnée par l\'éducation en santé.',
    contacts: [
      { relation: 'Époux', personnageId: 'p001' },
      { relation: 'Fils', personnageId: 'p003' },
      { relation: 'Fille', personnageId: 'p004' }
    ]
  },
  // Nouveaux personnages
  {
    id: 'p006',
    prenom: 'Lucie',
    nom: 'Bergeron',
    age: 28,
    sexe: 'F',
    profession: 'Infirmière aux urgences',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Célibataire',
    enfants: 0,
    groupeSanguin: 'B-',
    conditionsMedicales: [],
    medicaments: [],
    allergies: ['Latex'],
    traits: ['Dynamique', 'Résiliente', 'Perfectionniste'],
    comportement: ['Excellente en situation de crise', 'Tendance à négliger son propre bien-être'],
    histoire: 'Passionnée par son métier, elle travaille de nuit aux urgences depuis 5 ans.',
    contacts: []
  },
  {
    id: 'p007',
    prenom: 'Marc',
    nom: 'Dubois',
    age: 52,
    sexe: 'H',
    profession: 'Chef cuisinier',
    statutProfessionnel: 'Travailleur autonome',
    statutMatrimonial: 'Divorcé(e)',
    enfants: 1,
    groupeSanguin: 'A-',
    conditionsMedicales: [
      {
        nom: 'Diabète type 2',
        description: 'Diagnostiqué il y a 3 ans',
        medicaments: ['Metformine 850mg']
      }
    ],
    medicaments: ['Metformine 850mg'],
    allergies: [],
    traits: ['Créatif', 'Perfectionniste', 'Passionné'],
    comportement: ['Exigeant envers lui-même et les autres', 'Difficulté à déléguer'],
    histoire: 'Propriétaire d\'un restaurant réputé, il a appris la cuisine avec sa grand-mère.',
    contacts: [
      { relation: 'Fille', personnageId: 'p008' }
    ]
  },
  {
    id: 'p008',
    prenom: 'Sophie',
    nom: 'Dubois',
    age: 19,
    sexe: 'F',
    profession: 'Étudiante en psychologie',
    statutProfessionnel: 'Étudiant',
    statutMatrimonial: 'Célibataire',
    enfants: 0,
    groupeSanguin: 'A-',
    conditionsMedicales: [
      {
        nom: 'Anxiété',
        description: 'Trouble d\'anxiété généralisée',
        medicaments: ['Sertraline 50mg']
      }
    ],
    medicaments: ['Sertraline 50mg'],
    allergies: [],
    traits: ['Sensible', 'Intelligente', 'Créative'],
    comportement: ['Perfectionniste', 'Tendance à s\'inquiéter'],
    histoire: 'Étudiante brillante, passionnée par la psychologie et l\'art-thérapie.',
    contacts: [
      { relation: 'Père', personnageId: 'p007' }
    ]
  },
  {
    id: 'p009',
    prenom: 'Richard',
    nom: 'Lemieux',
    age: 67,
    sexe: 'H',
    profession: 'Retraité (ancien ingénieur)',
    statutProfessionnel: 'Retraité',
    statutMatrimonial: 'Marié(e)',
    enfants: 3,
    groupeSanguin: 'O+',
    conditionsMedicales: [
      {
        nom: 'Arthrose',
        description: 'Arthrose des genoux',
        medicaments: ['Acétaminophène 500mg']
      },
      {
        nom: 'Hypertension',
        description: 'Hypertension modérée',
        medicaments: ['Lisinopril 10mg']
      }
    ],
    medicaments: ['Acétaminophène 500mg', 'Lisinopril 10mg'],
    allergies: [],
    traits: ['Méthodique', 'Patient', 'Bricoleur'],
    comportement: ['Aime partager ses connaissances', 'Têtu concernant sa santé'],
    histoire: 'Retraité actif qui passe son temps à bricoler et à s\'occuper de ses petits-enfants.',
    contacts: [
      { relation: 'Épouse', personnageId: 'p010' }
    ]
  },
  {
    id: 'p010',
    prenom: 'Claudette',
    nom: 'Lemieux',
    age: 65,
    sexe: 'F',
    profession: 'Retraitée (ancienne bibliothécaire)',
    statutProfessionnel: 'Retraité',
    statutMatrimonial: 'Marié(e)',
    enfants: 3,
    groupeSanguin: 'A+',
    conditionsMedicales: [
      {
        nom: 'Ostéoporose',
        description: 'Diagnostiquée il y a 5 ans',
        medicaments: ['Calcium 500mg', 'Vitamine D 1000UI']
      }
    ],
    medicaments: ['Calcium 500mg', 'Vitamine D 1000UI'],
    allergies: ['Pénicilline'],
    traits: ['Organisée', 'Sociable', 'Attentionnée'],
    comportement: ['Très active dans sa communauté', 'Surprotectrice avec sa famille'],
    histoire: 'Passionnée de lecture, elle anime un club de lecture pour enfants à la bibliothèque locale.',
    contacts: [
      { relation: 'Époux', personnageId: 'p009' }
    ]
  },
  {
    id: 'p011',
    prenom: 'Kevin',
    nom: 'Martin',
    age: 24,
    sexe: 'H',
    profession: 'Mécanicien',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Célibataire',
    enfants: 0,
    groupeSanguin: 'B+',
    conditionsMedicales: [],
    medicaments: [],
    allergies: [],
    traits: ['Manuel', 'Débrouillard', 'Sociable'],
    comportement: ['Toujours prêt à aider', 'Impulsif'],
    histoire: 'Passionné de mécanique depuis son enfance, il travaille dans le garage familial.',
    contacts: []
  },
  {
    id: 'p012',
    prenom: 'Émilie',
    nom: 'Côté',
    age: 31,
    sexe: 'F',
    profession: 'Architecte',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Conjoint de fait',
    enfants: 1,
    groupeSanguin: 'AB+',
    conditionsMedicales: [
      {
        nom: 'Asthme',
        description: 'Asthme d\'effort',
        medicaments: ['Ventolin au besoin']
      }
    ],
    medicaments: ['Ventolin'],
    allergies: ['Arachides'],
    traits: ['Créative', 'Ambitieuse', 'Organisée'],
    comportement: ['Perfectionniste', 'Gère bien le stress'],
    histoire: 'Architecte talentueuse spécialisée dans les bâtiments écologiques.',
    contacts: [
      { relation: 'Conjoint', personnageId: 'p013' }
    ]
  },
  {
    id: 'p013',
    prenom: 'Thomas',
    nom: 'Roy',
    age: 33,
    sexe: 'H',
    profession: 'Développeur web',
    statutProfessionnel: 'Travailleur autonome',
    statutMatrimonial: 'Conjoint de fait',
    enfants: 1,
    groupeSanguin: 'O-',
    conditionsMedicales: [],
    medicaments: [],
    allergies: [],
    traits: ['Analytique', 'Calme', 'Introverti'],
    comportement: ['Travaille de longues heures', 'Passionné par la technologie'],
    histoire: 'Freelance depuis 5 ans, il travaille principalement avec des startups.',
    contacts: [
      { relation: 'Conjointe', personnageId: 'p012' }
    ]
  },
  {
    id: 'p014',
    prenom: 'Isabelle',
    nom: 'Gagnon',
    age: 48,
    sexe: 'F',
    profession: 'Directrice d\'école',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Divorcé(e)',
    enfants: 2,
    groupeSanguin: 'A+',
    conditionsMedicales: [
      {
        nom: 'Hypothyroïdie',
        description: 'Sous traitement depuis 10 ans',
        medicaments: ['Levothyroxine 75mcg']
      }
    ],
    medicaments: ['Levothyroxine 75mcg'],
    allergies: [],
    traits: ['Leader', 'Diplomate', 'Organisée'],
    comportement: ['Excellente en gestion de crise', 'Protectrice'],
    histoire: 'Directrice d\'école primaire depuis 8 ans, très impliquée dans sa communauté.',
    contacts: []
  },
  {
    id: 'p015',
    prenom: 'Pierre',
    nom: 'Bouchard',
    age: 55,
    sexe: 'H',
    profession: 'Pompier',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Marié(e)',
    enfants: 3,
    groupeSanguin: 'O+',
    conditionsMedicales: [],
    medicaments: [],
    allergies: [],
    traits: ['Courageux', 'Discipliné', 'Altruiste'],
    comportement: ['Calme sous pression', 'Protecteur'],
    histoire: 'Pompier depuis 30 ans, formateur pour les nouvelles recrues.',
    contacts: [
      { relation: 'Épouse', personnageId: 'p016' }
    ]
  },
  {
    id: 'p016',
    prenom: 'Louise',
    nom: 'Bouchard',
    age: 53,
    sexe: 'F',
    profession: 'Travailleuse sociale',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Marié(e)',
    enfants: 3,
    groupeSanguin: 'B+',
    conditionsMedicales: [
      {
        nom: 'Fibromyalgie',
        description: 'Diagnostic récent',
        medicaments: ['Duloxétine 30mg']
      }
    ],
    medicaments: ['Duloxétine 30mg'],
    allergies: [],
    traits: ['Empathique', 'Patiente', 'Résiliente'],
    comportement: ['Dévouée à aider les autres', 'Néglige parfois sa propre santé'],
    histoire: 'Travailleuse sociale spécialisée dans l\'aide aux familles en difficulté.',
    contacts: [
      { relation: 'Époux', personnageId: 'p015' }
    ]
  },
  {
    id: 'p017',
    prenom: 'Antoine',
    nom: 'Lavoie',
    age: 21,
    sexe: 'H',
    profession: 'Étudiant en kinésiologie',
    statutProfessionnel: 'Étudiant',
    statutMatrimonial: 'Célibataire',
    enfants: 0,
    groupeSanguin: 'A-',
    conditionsMedicales: [],
    medicaments: [],
    allergies: ['Fruits de mer'],
    traits: ['Sportif', 'Enthousiaste', 'Sociable'],
    comportement: ['Passionné par le sport', 'Toujours prêt à aider'],
    histoire: 'Étudiant en kinésiologie et entraîneur de basketball pour enfants.',
    contacts: []
  },
  {
    id: 'p018',
    prenom: 'Nathalie',
    nom: 'Morin',
    age: 39,
    sexe: 'F',
    profession: 'Vétérinaire',
    statutProfessionnel: 'Travailleur autonome',
    statutMatrimonial: 'Célibataire',
    enfants: 0,
    groupeSanguin: 'O+',
    conditionsMedicales: [
      {
        nom: 'Allergie aux chats',
        description: 'Allergie professionnelle',
        medicaments: ['Cétirizine 10mg']
      }
    ],
    medicaments: ['Cétirizine 10mg'],
    allergies: ['Chats'],
    traits: ['Dévouée', 'Professionnelle', 'Compatissante'],
    comportement: ['Passionnée par les animaux', 'Perfectionniste'],
    histoire: 'Propriétaire d\'une clinique vétérinaire, spécialisée dans les animaux exotiques.',
    contacts: []
  },
  {
    id: 'p019',
    prenom: 'Hugo',
    nom: 'Pelletier',
    age: 42,
    sexe: 'H',
    profession: 'Journaliste',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Divorcé(e)',
    enfants: 1,
    groupeSanguin: 'B-',
    conditionsMedicales: [
      {
        nom: 'Insomnie chronique',
        description: 'Troubles du sommeil',
        medicaments: ['Zopiclone 5mg']
      }
    ],
    medicaments: ['Zopiclone 5mg'],
    allergies: [],
    traits: ['Curieux', 'Perspicace', 'Déterminé'],
    comportement: ['Travailleur acharné', 'Parfois trop absorbé par son travail'],
    histoire: 'Journaliste d\'investigation, spécialisé dans les enquêtes environnementales.',
    contacts: []
  },
  {
    id: 'p020',
    prenom: 'Sarah',
    nom: 'Lambert',
    age: 29,
    sexe: 'F',
    profession: 'Graphiste',
    statutProfessionnel: 'Travailleur autonome',
    statutMatrimonial: 'Célibataire',
    enfants: 0,
    groupeSanguin: 'A+',
    conditionsMedicales: [
      {
        nom: 'Migraine',
        description: 'Migraines occasionnelles',
        medicaments: ['Ibuprofène 400mg au besoin']
      }
    ],
    medicaments: ['Ibuprofène 400mg'],
    allergies: [],
    traits: ['Créative', 'Indépendante', 'Minutieuse'],
    comportement: ['Perfectionniste', 'Travaille souvent tard'],
    histoire: 'Freelance en design graphique, spécialisée dans l\'identité de marque.',
    contacts: []
  },
  {
    id: 'p021',
    prenom: 'Michel',
    nom: 'Fortin',
    age: 58,
    sexe: 'H',
    profession: 'Chauffeur d\'autobus',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Marié(e)',
    enfants: 2,
    groupeSanguin: 'O+',
    conditionsMedicales: [
      {
        nom: 'Diabète type 2',
        description: 'Sous traitement oral',
        medicaments: ['Metformine 1000mg']
      }
    ],
    medicaments: ['Metformine 1000mg'],
    allergies: [],
    traits: ['Patient', 'Sociable', 'Ponctuel'],
    comportement: ['Attentif à la sécurité', 'Aime raconter des histoires'],
    histoire: 'Chauffeur d\'autobus scolaire depuis 25 ans, connu pour sa patience avec les enfants.',
    contacts: []
  },
  {
    id: 'p022',
    prenom: 'Julie',
    nom: 'Deschamps',
    age: 35,
    sexe: 'F',
    profession: 'Professeure de yoga',
    statutProfessionnel: 'Travailleur autonome',
    statutMatrimonial: 'Célibataire',
    enfants: 0,
    groupeSanguin: 'B+',
    conditionsMedicales: [],
    medicaments: [],
    allergies: ['Gluten'],
    traits: ['Zen', 'Spirituelle', 'Bienveillante'],
    comportement: ['Calme en toute situation', 'Prône le bien-être'],
    histoire: 'Ancienne avocate reconvertie en professeure de yoga, voyage régulièrement en Inde.',
    contacts: []
  },
  {
    id: 'p023',
    prenom: 'Robert',
    nom: 'Simard',
    age: 72,
    sexe: 'H',
    profession: 'Retraité (ancien dentiste)',
    statutProfessionnel: 'Retraité',
    statutMatrimonial: 'Veuf/Veuve',
    enfants: 3,
    groupeSanguin: 'A+',
    conditionsMedicales: [
      {
        nom: 'Hypertension',
        description: 'Sous contrôle médical',
        medicaments: ['Amlodipine 5mg']
      },
      {
        nom: 'Arthrite',
        description: 'Arthrite des mains',
        medicaments: ['Naproxène 375mg']
      }
    ],
    medicaments: ['Amlodipine 5mg', 'Naproxène 375mg'],
    allergies: [],
    traits: ['Sage', 'Généreux', 'Actif'],
    comportement: ['Aime partager son expérience', 'Très impliqué dans sa famille'],
    histoire: 'Retraité actif, fait du bénévolat dans une clinique dentaire communautaire.',
    contacts: []
  },
  {
    id: 'p024',
    prenom: 'Amélie',
    nom: 'Rousseau',
    age: 26,
    sexe: 'F',
    profession: 'Serveuse',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Célibataire',
    enfants: 0,
    groupeSanguin: 'O-',
    conditionsMedicales: [],
    medicaments: [],
    allergies: [],
    traits: ['Dynamique', 'Souriante', 'Organisée'],
    comportement: ['Excellente avec les clients', 'Travailleuse'],
    histoire: 'Étudiante en gestion hôtelière, travaille comme serveuse pour payer ses études.',
    contacts: []
  },
  {
    id: 'p025',
    prenom: 'François',
    nom: 'Leblanc',
    age: 45,
    sexe: 'H',
    profession: 'Électricien',
    statutProfessionnel: 'Travailleur autonome',
    statutMatrimonial: 'Marié(e)',
    enfants: 2,
    groupeSanguin: 'B+',
    conditionsMedicales: [
      {
        nom: 'Lombalgie chronique',
        description: 'Douleurs lombaires récurrentes',
        medicaments: ['Acétaminophène 500mg au besoin']
      }
    ],
    medicaments: ['Acétaminophène 500mg'],
    allergies: [],
    traits: ['Méticuleux', 'Professionnel', 'Fiable'],
    comportement: ['Très prudent au travail', 'Perfectionniste'],
    histoire: 'Électricien certifié depuis 20 ans, spécialisé dans les installations commerciales.',
    contacts: []
  },
  {
    id: 'p026',
    prenom: 'Catherine',
    nom: 'Bergeron',
    age: 32,
    sexe: 'F',
    profession: 'Pharmacienne',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Marié(e)',
    enfants: 1,
    groupeSanguin: 'A+',
    conditionsMedicales: [],
    medicaments: [],
    allergies: ['Pénicilline'],
    traits: ['Méthodique', 'Attentive', 'Professionnelle'],
    comportement: ['Excellente communicatrice', 'Soucieuse du détail'],
    histoire: 'Pharmacienne en milieu hospitalier, passionnée par la formation continue.',
    contacts: []
  },
  {
    id: 'p027',
    prenom: 'David',
    nom: 'Nguyen',
    age: 28,
    sexe: 'H',
    profession: 'Physiothérapeute',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Célibataire',
    enfants: 0,
    groupeSanguin: 'O+',
    conditionsMedicales: [],
    medicaments: [],
    allergies: [],
    traits: ['Sportif', 'Patient', 'Pédagogue'],
    comportement: ['Motivant avec ses patients', 'Passionné par son travail'],
    histoire: 'Physiothérapeute sportif, travaille avec des athlètes professionnels.',
    contacts: []
  },
  {
    id: 'p028',
    prenom: 'Sylvie',
    nom: 'Gauthier',
    age: 51,
    sexe: 'F',
    profession: 'Enseignante au primaire',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Divorcé(e)',
    enfants: 2,
    groupeSanguin: 'B-',
    conditionsMedicales: [
      {
        nom: 'Asthme',
        description: 'Asthme léger',
        medicaments: ['Ventolin au besoin']
      }
    ],
    medicaments: ['Ventolin'],
    allergies: ['Poussière'],
    traits: ['Patiente', 'Créative', 'Énergique'],
    comportement: ['Dévouée à ses élèves', 'Très organisée'],
    histoire: 'Enseignante passionnée depuis 25 ans, spécialisée en adaptation scolaire.',
    contacts: []
  },
  {
    id: 'p029',
    prenom: 'Martin',
    nom: 'Caron',
    age: 38,
    sexe: 'H',
    profession: 'Policier',
    statutProfessionnel: 'Employé',
    statutMatrimonial: 'Marié(e)',
    enfants: 1,
    groupeSanguin: 'A+',
    conditionsMedicales: [],
    medicaments: [],
    allergies: [],
    traits: ['Rigoureux', 'Calme', 'Professionnel'],
    comportement: ['Excellent en situation de crise', 'Protecteur'],
    histoire: 'Policier communautaire, impliqué dans les programmes de prévention jeunesse.',
    contacts: []
  },
  {
    id: 'p030',
    prenom: 'Mélanie',
    nom: 'Girard',
    age: 44,
    sexe: 'F',
    profession: 'Chef d\'entreprise',
    statutProfessionnel: 'Travailleur autonome',
    statutMatrimonial: 'Marié(e)',
    enfants: 2,
    groupeSanguin: 'AB+',
    conditionsMedicales: [
      {
        nom: 'Stress chronique',
        description: 'Sous suivi médical',
        medicaments: ['Anxiolytique au besoin']
      }
    ],
    medicaments: ['Anxiolytique'],
    allergies: [],
    traits: ['Ambitieuse', 'Leader', 'Déterminée'],
    comportement: ['Perfectionniste', 'Travaille sous pression'],
    histoire: 'Fondatrice d\'une entreprise de technologie en pleine croissance.',
    contacts: []
  }
];